import { registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";
import localeEn from "@angular/common/locales/en";
import localeFr from "@angular/common/locales/fr";
import localeEs from "@angular/common/locales/es";
import localeIt from "@angular/common/locales/it";
import localeDe from "@angular/common/locales/de";

import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from "@angular/core";
import { MAT_LUXON_DATE_ADAPTER_OPTIONS, provideLuxonDateAdapter } from "@angular/material-luxon-adapter";
import { DateAdapter, MAT_DATE_LOCALE } from "@angular/material/core";

import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideRouter } from "@angular/router";
import { getKeycloakConfig } from "@config/keycloak/keycloak.config";
import { translateServiceProvider } from "@config/locales/translate.config";
import { CustomLuxonAdapter } from "@config/luxon/custom-luxon-adapter";
import { AuthInterceptor } from "@auth/interceptors/auth.interceptor";
import { AuthService } from "@auth/interfaces/IAuthService";
import { KeycloakAuthService } from "@auth/services/keycloak-auth.service";
import { APP_ROUTES } from "@pages/app.routes";
import { provideKeycloak } from "keycloak-angular";
import { apolloProvider } from "./apollo/apollo.config";
import { localesProvider } from "./locales/locales.config";
import { cellDisplaySettingsProvider } from "@config/table/display.config";
import { organizationsProvider } from "@config/business/organization.config";
import { ubisolutionsProviders } from "@config/ubisolutions/ubisolutions.config";
import { MarkdownModule } from "ngx-markdown";
import { Chart, registerables } from "chart.js";

registerLocaleData(localeFr, "fr-FR");
registerLocaleData(localeEn, "en-US");
registerLocaleData(localeEs, "es-ES");
registerLocaleData(localeIt, "it-IT");
registerLocaleData(localeDe, "de-DE");
Chart.register(...registerables);

export const APP_CONFIG: ApplicationConfig = {
    providers: [
        provideHttpClient(withFetch()),
        importProvidersFrom(MarkdownModule.forRoot()),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(APP_ROUTES),
        provideAnimationsAsync(),
        provideLuxonDateAdapter(),
        apolloProvider,
        localesProvider,
        {
            provide: LOCALE_ID,
            useValue: "en-US",
        },
        {
            provide: MAT_DATE_LOCALE,
            useValue: "en-US",
        },
        {
            provide: DateAdapter,
            useClass: CustomLuxonAdapter,
            deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS],
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
        translateServiceProvider,
        provideKeycloak(getKeycloakConfig()),
        { provide: AuthService, useClass: KeycloakAuthService },
        cellDisplaySettingsProvider,
        organizationsProvider,
        ...ubisolutionsProviders,
    ],
};
